import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const IncomeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const columns = [
    {
      title: <div className="text-table">{t("income.label.code")}</div>,
      dataIndex: "code",
      key: "code",
      align: "center",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
    },
    {
      title: <div className="text-table">{t("income.label.name")}</div>,
      dataIndex: "income",
      key: "income",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.nameEn;
        }
        return record?.name;
      },
    },
    {
      title: <div className="text-table">{t("income.label.type")}</div>,
      dataIndex: "incomeType",
      key: "incomeType",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: (_, record) => {
        const { incomeType = {} } = record;
        if (i18n.language === "en") {
          return incomeType?.nameEn;
        }
        return incomeType?.name;
      },
    },
    {
      title: (
        <div className="text-table">{t("income.label.tax_calculation")}</div>
      ),
      dataIndex: "taxCalculation",
      key: "taxCalculation",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: (_, record) => {
        const { taxCalculation = {} } = record;
        if (i18n.language === "en") {
          return taxCalculation?.nameEn;
        }
        return taxCalculation?.name;
      },
    },
    {
      title: <div className="text-table">{t("income.label.off_period")}</div>,
      dataIndex: "offPeriod",
      key: "offPeriod",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
    },
    {
      title: (
        <div className="text-table">{t("income.label.previous_period")}</div>
      ),
      dataIndex: "previousPeriod",
      key: "previousPeriod",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
    },
    {
      title: <div className="text-table">{t("income.label.do_pay")}</div>,
      dataIndex: "do_pay",
      key: "do_pay",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: () => "-",
    },
    // {
    //   title: (
    //     <div className="text-table">{t("income.label.account_group")}</div>
    //   ),
    //   dataIndex: "accountGroup",
    //   key: "accountGroup",
    //   sorter: {
    //     compare: (a, b) => null,
    //     multiple: 5,
    //   },
    // },
    {
      title: <div className="text-table">{t("income.label.calculate")}</div>,
      dataIndex: "calculate",
      key: "calculate",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: () => "-",
    },
    {
      title: <div className="text-table">{t("income.label.welfare")}</div>,
      dataIndex: "welfare",
      key: "welfare",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: () => "-",
    },
    {
      title: <div className="text-table">{t("income.label.status")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      // sorter: {
      //   compare: (a, b) => null,
      //   multiple: 5,
      // },
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
          disabled={roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|INCOME") ? false : true}
        />
      ),
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|PAYROLL_SETTING|INCOME") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                // {
                //   key: "2",
                //   label: (
                //     // eslint-disable-next-line jsx-a11y/anchor-is-valid
                //     <a
                //       href="#"
                //       onClick={(e) => {
                //         e.preventDefault();
                //         onDelete(record);
                //       }}
                //       style={{ color: "grey", fontSize: "14px" }}
                //     >
                //       {t("action.delete")}
                //     </a>
                //   ),
                //   icon: (
                //     <DeleteOutlined
                //       style={{ fontSize: "18px", color: "gray" }}
                //     />
                //   ),
                // },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.incomeDeducationId}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default IncomeTable;
